import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { preRegistrationRoutes } from '../utils/routes.utils';
import { MUNICIPALITY_KIND_LABELS, formatDateOnly } from '../utils/format.utils';
import type { MunicipalListSummary } from '../types/pre-registration.types';

interface MunicipalListsTableProps {
  items: MunicipalListSummary[];
}

export const MunicipalListsTable: React.FC<MunicipalListsTableProps> = ({ items }) => {
  const navigate = useNavigate();

  return (
    <Table className="border border-gray-200">
      <TableHeader className="bg-gray-100">
        <TableRow>
          <TableHead>Municipio</TableHead>
          <TableHead>Departamento</TableHead>
          <TableHead>Región</TableHead>
          <TableHead>Fecha de relevamiento</TableHead>
          <TableHead>Responsable de carga</TableHead>
          <TableHead className="text-right">Alojamientos</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {items.map((list) => (
          <TableRow
            key={list.id}
            className="cursor-pointer"
            onClick={() => navigate(preRegistrationRoutes.municipalList(list.id))}
          >
            <TableCell>
              <div className="font-medium">{list.municipality.name}</div>
              <div className="text-xs text-gray-500">
                {MUNICIPALITY_KIND_LABELS[list.municipality.kind]}
              </div>
            </TableCell>
            <TableCell>{list.municipality.department.name}</TableCell>
            <TableCell>{list.municipality.department.region.name}</TableCell>
            <TableCell>{formatDateOnly(list.surveyDate)}</TableCell>
            <TableCell>{list.listManagerName ?? '—'}</TableCell>
            <TableCell className="text-right">
              <div>{list.accommodationsCount}</div>
              {list.deletedAccommodationsCount > 0 && (
                <div className="text-xs text-gray-500">
                  {list.deletedAccommodationsCount}{' '}
                  {list.deletedAccommodationsCount === 1 ? 'eliminado' : 'eliminados'}
                </div>
              )}
              {list.pendingNotificationCount > 0 && (
                <Badge
                  variant="secondary"
                  className="mt-1 whitespace-nowrap bg-amber-100 text-amber-800 hover:bg-amber-100"
                >
                  {list.pendingNotificationCount} sin notificar
                </Badge>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
